<template>
  <el-form-item :label-width="itemRender.width" :label="itemRender.label" :required="itemRender.required ? true : false">
    <div class="phoneNumber">
      <span>+86</span>
      <el-input disabled v-model="itemRender.value" :placeholder="itemRender.placeholder ? itemRender.placeholder : '请输入'
        "></el-input>
    </div>

    <div class="phone" v-if="itemRender.phoneType == 2">
      <el-radio-group v-model="itemRender.phoneValue" size="mini">
        <el-radio-button disabled size="mini" :label="1">手机</el-radio-button>
        <el-radio-button disabled :label="3">固话</el-radio-button>
      </el-radio-group>
    </div>
  </el-form-item>
</template>

<script>
export default {
  props: {
    itemRender: {
      type: Object,
      default: () => {
        return {};
      },
    },
  },
  methods: {},
};
</script>

<style lang="scss" scoped>
::v-deep .el-radio-group {
  display: flex;
  flex-wrap: wrap;
  justify-content: flex-start;

  .el-radio {
    margin-bottom: 12px;
  }
}

.vacate {
  .vacate-item {
    display: flex;
    align-items: center;
    margin-bottom: 8px;
    padding: 0 0 8px;
    border-bottom: 1px solid #dfe2e8;

    ::v-deep .el-input__inner {
      border: 0;
    }

    span {
      width: 100px;
    }
  }
}

.el-form-item {
  position: relative;

  .phone {
    position: absolute;
    right: 10px;
    top: 0px;
  }

  .phoneNumber {
    display: flex;
    align-items: center;
    border: 1px solid #dfe2e8;
    padding: 0 8px;

    ::v-deep .el-input__inner {
      border: 0;
    }

    span {
      padding-right: 8px;
      border-right: 1px solid #dfe2e8;
    }
  }

  .enclosure {
    display: flex;
    align-items: center;
    color: #999999;

    i {
      color: #5794f6;
      font-size: 18px;
      font-weight: bold;
      margin-right: 8px;
    }
  }
}

.money {
  .div {
    margin-top: 12px;
  }
}
</style>
